export default __webpack_public_path__ + "static/media/9.9075dbb4.jpg";